import React, { FC } from "react";
import { EmptyDashboard } from "@modules/dashboards/empty/empty";
import { getEmptyTextBlock } from "@modules/dashboards/empty/common";

interface EmptyProps {
    name: string;
}

enum stateCropsNames {
    weeds = "Сорняки",
    pests = "Вредители",
    disease = "Болезни",
}

const getPestsSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="289" viewBox="0 0 599 289" fill="none">
            <path d="M1 4V241H574" stroke="#CCD9E0" stroke-miterlimit="3.93356" />
            <rect x="1" y="254" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="50.6667" y="254" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="100.333" y="254" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="150" y="254" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="199.667" y="254" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="249.333" y="254" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="299" y="254" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="348.667" y="254" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="398.333" y="254" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="448" y="254" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="497.667" y="254" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="547.333" y="254" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <path
                d="M8 235L15 234.983L22 234.959L29 234.924L36 234.875L43 234.807L50 234.714L57 234.586L64 234.413L71 234.183L78 233.879L85 233.483L92 232.971L99 232.317L106 231.493L113 230.464L120 229.195L127 227.648L134 225.784L141 223.565L148 220.955L155 217.924L162 214.447L169 210.509L176 206.109L183 201.26L190 195.989L197 190.346L204 184.396L211 178.224L218 171.935L225 165.646L232 159.49L239 153.606L246 148.138L253 143.224L260 138.999L267 135.578L274 133.06L281 131.519L288 131L295 131.519L302 133.06L309 135.578L316 138.999L323 143.224L330 148.138L337 153.606L344 159.49L351 165.646L358 171.935L365 178.224L372 184.396L379 190.346L386 195.989L393 201.26L400 206.109L407 210.509L414 214.447L421 217.924L428 220.955L435 223.565L442 225.784L449 227.648L456 229.195L463 230.464L470 231.493L477 232.317L484 232.971L491 233.483L498 233.879L505 234.183L512 234.413L519 234.586L526 234.714L533 234.807L540 234.875L547 234.924L554 234.959L561 234.983L568 235"
                stroke="#EAEAEB"
                stroke-width="2"
            />
            <rect width="598" height="289" transform="translate(1)" fill="url(#paint0_linear_6718_60546)" />
            <defs>
                <linearGradient
                    id="paint0_linear_6718_60546"
                    x1="299"
                    y1="-21.4068"
                    x2="299"
                    y2="262.064"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};

const getDiseaseSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="285" viewBox="0 0 599 285" fill="none">
            <path d="M1 0V237H574" stroke="#CCD9E0" stroke-miterlimit="3.93356" />
            <rect x="1" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="50.6667" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="100.333" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="150" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="199.667" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="249.333" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="299" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="348.667" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="398.333" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="448" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="497.667" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="547.333" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <path
                d="M8 231L15 230.967L22 230.92L29 230.852L36 230.757L43 230.624L50 230.441L57 230.191L64 229.855L71 229.405L78 228.812L85 228.038L92 227.039L99 225.764L106 224.154L113 222.146L120 219.669L127 216.649L134 213.011L141 208.68L148 203.586L155 197.669L162 190.881L169 183.196L176 174.608L183 165.142L190 154.854L197 143.839L204 132.224L211 120.178L218 107.901L225 95.6264L232 83.6104L239 72.1258L246 61.4514L253 51.8611L260 43.6126L267 36.9355L274 32.021L281 29.0128L288 28L295 29.0128L302 32.021L309 36.9355L316 43.6126L323 51.8611L330 61.4514L337 72.1258L344 83.6104L351 95.6264L358 107.901L365 120.178L372 132.224L379 143.839L386 154.854L393 165.142L400 174.608L407 183.196L414 190.881L421 197.669L428 203.586L435 208.68L442 213.011L449 216.649L456 219.669L463 222.146L470 224.154L477 225.764L484 227.039L491 228.038L498 228.812L505 229.405L512 229.855L519 230.191L526 230.441L533 230.624L540 230.757L547 230.852L554 230.92L561 230.967L568 231"
                stroke="#EAEAEB"
                stroke-width="2"
            />
            <rect width="598" height="285" transform="translate(1)" fill="url(#paint0_linear_6718_60547)" />
            <defs>
                <linearGradient
                    id="paint0_linear_6718_60547"
                    x1="299"
                    y1="-21.1105"
                    x2="299"
                    y2="258.436"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};

const getWeedsSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="285" viewBox="0 0 599 285" fill="none">
            <path d="M1 0V237H574" stroke="#CCD9E0" stroke-miterlimit="3.93356" />
            <rect x="1" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="50.6667" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="100.333" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="150" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="199.667" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="249.333" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="299" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="348.667" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="398.333" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="448" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="497.667" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <rect x="547.333" y="250" width="20.6667" height="8" rx="2" fill="#EAEAEB" />
            <path
                d="M534 203.812L527.085 198.132C520.171 192.453 506.342 181.093 492.513 174.585C478.684 168.078 464.855 166.423 451.026 176.327C437.197 186.231 423.368 207.694 409.539 212.75C395.71 217.806 381.881 206.455 368.052 197.824C354.223 189.193 340.394 183.282 326.565 187.153C312.736 191.023 298.907 204.674 285.078 202.044C271.249 199.413 257.42 180.501 243.591 178.918C229.762 177.336 215.933 59.8927 202.104 62.643C188.274 65.3932 174.445 82.5216 160.616 79.8037C146.787 77.0857 132.958 54.5213 119.129 60.0749C105.3 65.6284 91.4714 71.9249 77.6424 79.8037C63.8133 87.6826 53.829 36.4153 40 38.0377"
                stroke="#EAEAEB"
                stroke-width="2"
            />
            <rect width="598" height="285" transform="translate(1)" fill="url(#paint0_linear_6718_60548)" />
            <defs>
                <linearGradient
                    id="paint0_linear_6718_60548"
                    x1="299"
                    y1="-21.1105"
                    x2="299"
                    y2="258.436"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};

const getSvgByName = (name: string) => {
    switch (name) {
        case stateCropsNames.disease:
            return getDiseaseSvg();
        case stateCropsNames.pests:
            return getPestsSvg();
        case stateCropsNames.weeds:
            return getWeedsSvg();
        default:
            return getWeedsSvg();
    }
};

export const Empty: FC<EmptyProps> = ({ name }) => {
    return <EmptyDashboard name={name} content={getSvgByName(name)} emptyTextBlock={getEmptyTextBlock()} />;
};